import { METERS_PER_UNIT } from 'ol/proj';

/**
 * Set angle value between 0 and 360 exclude.
 * @param {number} angle angle in degree.
 * @returns {number} angle value betwenn 0 and 360.
 */
export function correctDegreeAngle(angle) {
  angle %= 360;
  return angle < 0 ? angle + 360 : angle;
}

/**
 * Turn a distance from nautic to map distance.
 * @param {number} distance Distance in nautic.
 * @param {ol.Map} map The openlayers map.
 * @returns The distance on the map corresponding to the parameter in nautic.
 */
export function fromNauticToMapDistance(distance, map) {
  const view = map.getView();
  const projection = view.getProjection();
  const resolutionAtEquator = view.getResolution();
  const center = view.getCenter();
  const pointResolution = projection.getPointResolutionFunc_(resolutionAtEquator, center);
  const resolutionFactor = resolutionAtEquator / pointResolution;
  return (distance / METERS_PER_UNIT.m) * resolutionFactor * 1852;
}
